import { Box, Button, Divider, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const UfBox = styled(Box)(() => ({
  width: '220px',
  marginBottom: '20px',
}));

export const SectionTitleContainer = styled(Box)(() => ({
  marginTop: '20px',
  display: 'flex',
  flexWrap: 'nowrap',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  gap: '10px',
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  minWidth: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '21px',
  fontWeight: '600',
  cursor: 'pointer',
  '& span': { color: theme.palette.secondary.main },
}));

export const DividerContainer = styled(Box)(() => ({
  width: '100%',
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  borderBottomWidth: '2px',
  borderBottomColor: theme.palette.secondary.main,
}));

export const Subtitle = styled(Typography)(() => ({
  fontSize: '18px',
  color: '#707070',
  fontWeight: '600',
}));

export const UpdateBox = styled(Box)(() => ({
  marginBottom: '60px',
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const UpdateButton = styled(Button)(({ theme }) => ({
  width: '400px',
  backgroundColor: theme.palette.secondary.main,
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));
